import React from 'react';
import { Link } from 'react-router-dom';

const TOOL_LINKS = [
  {
    to: '/mountain-log',
    title: '登山記録',
    description: '登頂した山を記録して振り返る',
  },
  {
    to: '/fare-split',
    title: '交通費ワリカン',
    description: 'ガソリン代・高速代をまとめて精算',
  },
  {
    to: '/mountain-type',
    title: '登山タイプ診断',
    description: '16タイプで分かるあなたの山スタイル',
  },
  {
    href: 'https://yamano-media.com/blog/mountain-checker-app/',
    title: '登山装備チェック',
    description: '忘れ物を減らす持ち物チェックリスト',
  },
  {
    href: 'https://yamano-media.com/blog/trek-cal/',
    title: '行動食計算',
    description: '山行時間に合わせた補給量の目安確認',
  },
  {
    href: 'https://yamano-media.com/blog/word/',
    title: '山のことば辞典',
    description: '登山用語をすばやく確認',
  },
];

const MEDIA_LINKS = [
  {
    href: 'https://yamano-media.com/blog/',
    title: 'ヤマノブログ',
    description: 'このサービスの母体となる登山メディア',
  },
  {
    href: 'https://x.com/yamaloglist',
    title: '開発者 X',
    description: '更新情報と開発まわりの発信',
  },
];

function SidebarSection({ eyebrow, title, links }) {
  return (
    <section className="desktop-tool-sidebar__section">
      <p className="desktop-tool-sidebar__eyebrow">{eyebrow}</p>
      <h2 className="desktop-tool-sidebar__title">{title}</h2>
      <div className="desktop-tool-sidebar__list">
        {links.map((link) =>
          link.to ? (
            <Link
              key={link.to}
              to={link.to}
              className="desktop-tool-sidebar__link"
            >
              <span className="desktop-tool-sidebar__link-title">{link.title}</span>
              <span className="desktop-tool-sidebar__link-desc">{link.description}</span>
            </Link>
          ) : (
            <a
              key={link.href}
              href={link.href}
              className="desktop-tool-sidebar__link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="desktop-tool-sidebar__link-title">{link.title}</span>
              <span className="desktop-tool-sidebar__link-desc">{link.description}</span>
            </a>
          )
        )}
      </div>
    </section>
  );
}

function DesktopToolSidebar() {
  return (
    <aside className="desktop-tool-sidebar" aria-label="外部リンク">
      <div className="desktop-tool-sidebar__card">
        <SidebarSection eyebrow="Tools" title="登山ツール" links={TOOL_LINKS} />
        <SidebarSection eyebrow="Media" title="メディア" links={MEDIA_LINKS} />
      </div>
    </aside>
  );
}

export default DesktopToolSidebar;
